import { PaymentModuleId } from '@foundation/apis/payments';
import Clarity from '@microsoft/clarity';
import { useAuth } from '@shared/auth';
import { useTranslation } from '@shared/localization';
import { JSX } from 'react';

import { RedirectStatus } from '@/components/contexts/params';
import { PayButton } from '@/components/pages/stored-instruments/utils/PayButton';
import { useUserFriendlyPaymentModuleName } from '@/hooks/useUserFriendlyPaymentModuleName';
import { triggerErrorToast } from '@/libs/toasts';
import Logger, { LoggerOrigin } from '@/services/Logger';
import NavigationService, {
  InternalPage,
} from '@/services/navigation/NavigationService';
import SubsidiaryCardViaTerminalOnPickupService from '@/services/subsidiary/SubsidiaryCardViaTerminalOnPickupService';
import TelemetryService from '@/services/telemetry/TelemetryService';

interface IPaymentInSubsidiaryCardViaTerminalOnPickupBtnProps {
  readonly navigation?: JSX.Element | null;
}

export function PaymentInSubsidiaryCardViaTerminalOnPickupBtn({
  navigation,
}: IPaymentInSubsidiaryCardViaTerminalOnPickupBtnProps) {
  const { accessToken } = useAuth();
  const { t } = useTranslation();
  const paymentModuleT = useUserFriendlyPaymentModuleName();

  return (
    <div className="flex space-x-2">
      {navigation}
      <PayButton
        onClick={() => {
          const currentPage = NavigationService.getInternalPage();
          NavigationService.navigateTo({ page: InternalPage.StatusProcessing });
          SubsidiaryCardViaTerminalOnPickupService.authorise(accessToken ?? '')
            .then(() => {
              NavigationService.navigateTo({
                page: InternalPage.PaymentInSubsidiaryStatusSuccess,
              });
              Clarity.setTag('pay', [
                RedirectStatus.Success,
                paymentModuleT(
                  PaymentModuleId.PaymentInSubsidiaryCardViaTerminalOnPickup,
                ),
              ]);
            })
            .catch((err) => {
              NavigationService.navigateTo(currentPage);
              TelemetryService.trackException(
                err,
                'SubsidiaryCardViaTerminalOnPickupBtn',
              );
              Logger.error(
                LoggerOrigin.ReactComponent,
                'Payment at subsidiary with EC/Card via Terminal on Pickup failed',
                err,
              );
              triggerErrorToast(
                t('Something went wrong!'),
                t(
                  'Failed to authorize payment with EC/Card via Terminal on Pickup.',
                ),
              );
              Clarity.setTag('pay', [
                RedirectStatus.Failure,
                paymentModuleT(
                  PaymentModuleId.PaymentInSubsidiaryCardViaTerminalOnPickup,
                ),
              ]);
            });
        }}
      />
    </div>
  );
}
